import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import "./ExtensionsFilter.css";
import useUserDetails from "../../../../utils/auth/UserDetails";
import getExtensionsByUserId from "../../../../utils/ExtensionHandlingUtils/getExtensionsByUserId";
import getPublicExtensions from "../../../../utils/ExtensionHandlingUtils/getPublicExtensions";

const ExtensionsFilter = ({ onFilterChange }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const userDetails = useUserDetails();
    const [userExtensions, setUserExtensions] = useState([]);
    const [featuredExtensions, setFeaturedExtensions] = useState([]);
    const [isLoadingUserExtensions, setIsLoadingUserExtensions] = useState(true);
    const [isLoadingFeatured, setIsLoadingFeatured] = useState(true);

    useEffect(() => {
        const fetchUserExtensions = async () => {
            if (!userDetails?.userId) {
                setIsLoadingUserExtensions(false);
                return;
            }
            try {
                setIsLoadingUserExtensions(true);
                const fetched = await getExtensionsByUserId(userDetails.userId);
                setUserExtensions(fetched);
            } catch (error) {
                console.error("Error loading user extensions:", error);
            } finally {
                setIsLoadingUserExtensions(false);
            }
        };
        fetchUserExtensions();
    }, [userDetails]);

    useEffect(() => {
        const fetchFeatured = async () => {
            try {
                setIsLoadingFeatured(true);
                const publicExts = await getPublicExtensions(userDetails?.userId, userDetails?.username);
                setFeaturedExtensions(publicExts);
            } catch (error) {
                console.error("Error loading public extensions:", error);
            } finally {
                setIsLoadingFeatured(false);
            }
        };
        fetchFeatured();
    }, [userDetails]);

    useEffect(() => {
        const combinedExtensions = [...userExtensions, ...featuredExtensions];
        const uniqueCategories = Array.from(
            new Set(combinedExtensions.map(ext => ext.category).filter(Boolean))
        ).map(category => ({ label: category, value: category }));

        setCategories([{ label: "All Categories", value: null }, ...uniqueCategories]);
    }, [userExtensions, featuredExtensions]);

    useEffect(() => {
        const selectedFilters = { category: selectedCategory, search: searchTerm };
        // console.log(selectedFilters);
        onFilterChange(selectedFilters);
    }, [selectedCategory, searchTerm, onFilterChange]);

    return (
        <div className="extensions-filter">
            <div className="filter-group">
                <label htmlFor="category">Extension Category</label>
                <Dropdown
                    id="category"
                    value={selectedCategory}
                    options={categories}
                    onChange={(e) => setSelectedCategory(e.value)}
                    placeholder="Select an Extension Category"
                    className="p-dropdown"
                />
            </div>
            <div className="filter-group">
                <label htmlFor="search">Search Extensions</label>
                <InputText
                    id="search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Type to search extensions..."
                    className="p-inputtext"
                />
            </div>

        </div>
    );
};

export default ExtensionsFilter;
